const GUEST_KEY = 'storefront_guest_ok';
const AUTH_OK_KEY = 'storefront_auth_ok';
const LOGIN_NONCE_KEY = 'storefront_login_nonce';
const LOGIN_INTENT_KEY = 'storefront_login_intent';

function getAuthOk() {
  try {
    if (window.localStorage.getItem(AUTH_OK_KEY) === '1') return true;
  } catch {
    // ignore
  }
  try {
    if (window.sessionStorage.getItem(AUTH_OK_KEY) === '1') return true;
  } catch {
    // ignore
  }
  return false;
}

function setAuthOk() {
  try {
    window.localStorage.setItem(AUTH_OK_KEY, '1');
  } catch {
    // ignore
  }
  try {
    window.sessionStorage.setItem(AUTH_OK_KEY, '1');
    // If user is authenticated, guest restrictions should not apply anymore.
    window.sessionStorage.removeItem(GUEST_KEY);
    window.sessionStorage.removeItem(LOGIN_INTENT_KEY);
    window.sessionStorage.removeItem(LOGIN_NONCE_KEY);
  } catch {
    // ignore
  }
  try {
    window.localStorage.removeItem(LOGIN_INTENT_KEY);
  } catch {
    // ignore
  }
}

function clearAuthOk() {
  try {
    window.localStorage.removeItem(AUTH_OK_KEY);
  } catch {
    // ignore
  }
  try {
    window.sessionStorage.removeItem(AUTH_OK_KEY);
  } catch {
    // ignore
  }
}

/**
 * @param {unknown} value
 * @returns {string | null}
 */
function normalizeCustomerId(value) {
  if (value == null) return null;
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) return String(value);
  if (typeof value === 'string' && /^\d+$/.test(value) && Number(value) > 0) return value;
  return null;
}

function detectLoggedInCustomerId() {
  // These globals are typically injected by Shopify in `content_for_header`.
  // We avoid storage-based checks here to survive domain/preview URL changes.
  try {
    /** @type {any} */
    const w = window;
    const a = w.ShopifyAnalytics;
    const customerId1 = normalizeCustomerId(a?.meta?.page?.customerId);
    if (customerId1) return customerId1;
    const customerId2 = normalizeCustomerId(a?.meta?.page?.customer?.id);
    if (customerId2) return customerId2;
  } catch {
    // ignore
  }

  try {
    // `__st` is commonly used by Shopify storefront scripts.
    /** @type {any} */
    const w = window;
    const st = w.__st;
    const customerId3 = normalizeCustomerId(st?.cid);
    if (customerId3) return customerId3;
  } catch {
    // ignore
  }

  return null;
}

function forceAuthIfLoggedIn() {
  if (getAuthOk()) return true;

  const customerId = detectLoggedInCustomerId();
  if (!customerId) return false;

  setAuthOk();
  syncCustomerState();
  return true;
}

function syncCustomerState() {
  try {
    const authOk = getAuthOk();
    const guestOk = window.sessionStorage.getItem(GUEST_KEY) === '1';
    const currentState = document.documentElement.dataset.customerState;

    if (authOk) {
      document.documentElement.dataset.customerState = 'auth';
      return;
    }

    // Keep home "locked" state until user logs in or continues as guest.
    if (currentState === 'locked' && !guestOk) {
      return;
    }

    // Guest browsing should keep the same product visibility as normal browsing.
    delete document.documentElement.dataset.customerState;
  } catch {
    // ignore
  }
}

function setGuestOk() {
  try {
    window.sessionStorage.setItem(GUEST_KEY, '1');
    syncCustomerState();
  } catch {
    // ignore
  }
}

function initGuestContinue() {
  const el = document.querySelector('[data-guest-continue]');
  if (!el) return;

  el.addEventListener('click', () => {
    setGuestOk();
  });

  // If we arrived with ?guest=1, persist and clean URL.
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('guest') === '1') {
      setGuestOk();
      url.searchParams.delete('guest');
      window.history.replaceState({}, '', url.toString());
      syncCustomerState();
    }
  } catch {
    // ignore
  }
}

function generateNonce() {
  try {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }
}

function initOtpLogin() {
  // Use event delegation so dynamically replaced CTAs still work.
  document.addEventListener(
    'click',
    (e) => {
    const target = e.target instanceof Element ? e.target.closest('[data-otp-login]') : null;
    if (!target) return;

    e.preventDefault();

    const nonce = generateNonce();
    try {
        sessionStorage.setItem(LOGIN_INTENT_KEY, '1');
      sessionStorage.setItem(LOGIN_NONCE_KEY, nonce);
        try {
          localStorage.setItem(LOGIN_INTENT_KEY, '1');
        } catch {
          // ignore
        }
    } catch {
      // If storage fails, fall back to default href behavior
      const href = target.getAttribute('href') || '/customer_authentication/login';
      window.location.href = href;
      return;
    }

    // Return to current page by default, or to a custom path if provided.
    // (Use relative URL only; Shopify expects a storefront path.)
    const baseReturnTo =
      target.getAttribute('data-otp-return-to') || `${window.location.pathname}${window.location.search}`;

    let returnUrl;
    try {
      const url = new URL(baseReturnTo, window.location.origin);
      url.searchParams.set('auth_cb', '1');
      url.searchParams.set('nonce', nonce);
      returnUrl = `${url.pathname}${url.search}`;
    } catch {
      returnUrl = `/?auth_cb=1&nonce=${encodeURIComponent(nonce)}`;
    }

    const loginUrl = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;
    window.location.href = loginUrl;
    },
    true
  );
}

function initPasswordToggles() {
  const toggles = document.querySelectorAll('[data-password-toggle]');
  if (!toggles.length) return;

  toggles.forEach((btn) => {
    const targetId = btn.getAttribute('aria-controls');
    if (!targetId) return;
    const input = document.getElementById(targetId);
    if (!(input instanceof HTMLInputElement)) return;

    const labelShow = btn.getAttribute('data-label-show') || 'Show password';
    const labelHide = btn.getAttribute('data-label-hide') || 'Hide password';

    btn.addEventListener('click', () => {
      const isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';
      btn.textContent = isPassword ? labelHide : labelShow;
      btn.setAttribute('aria-pressed', String(isPassword));
    });
  });
}

function initRegisterPasswordConfirm() {
  const form = document.querySelector('form#create_customer');
  if (!(form instanceof HTMLFormElement)) return;

  const password = form.querySelector('#RegisterPassword');
  const confirm = form.querySelector('#RegisterPasswordConfirm');
  const mismatch = document.querySelector('[data-password-mismatch]');

  if (!(password instanceof HTMLInputElement) || !(confirm instanceof HTMLInputElement)) return;

  /**
   * @param {boolean} show
   */
  function showMismatch(show) {
    if (!(mismatch instanceof HTMLElement)) return;
    mismatch.classList.toggle('customer-auth__error--hidden', !show);
  }

  form.addEventListener('submit', (e) => {
    showMismatch(false);

    if (password.value !== confirm.value) {
      e.preventDefault();
      showMismatch(true);
      confirm.focus();
    }
  });
}

function initContactPhoneValidation() {
  /** @type {HTMLInputElement | null} */
  const el = document.querySelector('#ContactForm-phone');
  if (!el) return;
  /** @type {HTMLInputElement} */
  const input = el;

  const message = '10桁または11桁の数字で入力してください';
  const re = /^[0-9]{10,11}$/;

  function applyCustomValidity() {
    // For required empty state, let the browser show its default message.
    if (input.validity.valueMissing) {
      input.setCustomValidity('');
      return;
    }

    if (re.test(input.value)) {
      input.setCustomValidity('');
      return;
    }

    input.setCustomValidity(message);
  }

  input.addEventListener('input', () => {
    // Clear any previous message while typing, then re-apply based on current value.
    input.setCustomValidity('');
    applyCustomValidity();
  });

  input.addEventListener('blur', () => {
    applyCustomValidity();
  });

  input.addEventListener('invalid', () => {
    applyCustomValidity();
  });
}

initGuestContinue();
initOtpLogin();
initPasswordToggles();
initRegisterPasswordConfirm();
initContactPhoneValidation();
syncCustomerState();

// If the browser is already authenticated (from another tab), ensure we don't stay in "guest" mode.
if (getAuthOk()) {
  setAuthOk();
  syncCustomerState();
}

// If Shopify's injected globals indicate the customer is logged in, force auth state.
forceAuthIfLoggedIn();
[0, 250, 1000, 3000].forEach((delay) => {
  window.setTimeout(() => {
    forceAuthIfLoggedIn();
  }, delay);
});

window.addEventListener('pageshow', () => {
  forceAuthIfLoggedIn();
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    forceAuthIfLoggedIn();
  }
});

// Best-effort: clear auth marker on logout routes.
try {
  const p = window.location.pathname;
  if (p.includes('/account/logout') || p.includes('/customer_authentication/logout')) {
    clearAuthOk();
    try {
      window.sessionStorage.removeItem(GUEST_KEY);
    } catch {
      // ignore
    }
    syncCustomerState();
  }
} catch {
  // ignore
}

